import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MaterialModule } from '@app/shared/material.module';
export type loadingType = 'select' | 'table' | 'box' | string;

@Component({
    selector: 'tc-table-loading',
    imports: [
        CommonModule,
        MaterialModule
    ],
    templateUrl: './table-loading.component.html',
    styleUrls: ['./table-loading.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TableLoadingComponent implements OnInit {
  @Input() type: loadingType = 'box';
  diameter = 50;

  constructor() { }

  ngOnInit() {
    this.setup();
  }

  setup(): void {
    if (this.type == 'select') {
      this.diameter = 30;
    }
  }

}

